import { render, staticRenderFns } from "./term-popover.vue?vue&type=template&id=44ae23dd&"
import script from "./term-popover.vue?vue&type=script&lang=js&"
export * from "./term-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports